import { AnyAction } from "redux";
import { Dispatch } from "react";
import { ProjectRaw, Result } from "../../../../interfaces";
import { Create } from "../../../projects";
import { Adapter } from "../../../../shared/adapter";
import { ProjectsAdapter } from "../../../../adapter/projects-adapter";

export const FETCH_CREATE_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_CREATE_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_CREATE_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateProjectsRequest = () => {
    return {
        type: FETCH_CREATE_PROJECTS_REQUEST,
    };
};

const fetchCreateProjectsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_PROJECTS_SUCCESS,
        payload: data
    };
};

const fetchCreateProjectsFailure = (error: any) => {
    return {
        type: FETCH_CREATE_PROJECTS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (project:ProjectRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateProjectsRequest());
        try {
            const response = await Create(project);
            dispatch(fetchCreateProjectsSuccess(
                Adapter.from(response.data).to((value) => new ProjectsAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateProjectsFailure(error.message));
        }
    };
};